export default function ({ route, error }) {
  const gonePages = [
    '/about_service%20copy/',
    '/about_service%20copy/for-training/',
    '/about_service%20copy/for-presentation/',
    '/about_service%20copy/for-coaching/',
  ]
  if (gonePages.includes(route.path)) {
    error({ statusCode: 410 })
  }
}
